import React, { useContext } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import { GlobalContext } from '../../context';
import { Box, Flex, MobileNavbar, Menu } from '..';
import { useMediaQuery } from '../../hooks';
import { theme } from '../../style';

const Dropdown = styled(Flex)`
  .button {
    text-transform: none;
    font-family: ${theme.fonts.primary};
    font-size: 16px;
    color: black;
    border: none;
    text-decoration: none;
    cursor: pointer;
  }

  .dropdown {
    position: relative;

    .dropdown-menu {
      position: absolute;
      left: 0;
      top: calc(100% + 28px);
      z-index: 10001;
      opacity: 0;
      visibility: hidden;

      padding: 20px;
      background-color: rgba(255, 255, 255);
      border-radius: 14px;
      box-shadow: rgb(0 0 0 / 10%) 0px 8px 16px, rgb(0 0 0 / 8%) 0px 4px 8px;

      transform: translateY(-10px);
      transition: all 0.2s ease-in-out;

      @supports (backdrop-filter: none) {
        backdrop-filter: blur(16px);
        background-color: rgba(255, 255, 255, 0.8);
      }
    }

    &:hover {
      .button {
        background-color: ${theme.colors.grey.v1};
      }
      .dropdown-menu {
        visibility: visible;
        opacity: 1;
        transform: translateY(0);
      }
    }

    &.active {
      > .button {
        background-color: ${theme.colors.grey.v1};

        + {
          .dropdown-menu {
            visibility: visible;
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
    }
  }
`;

const ButtonBox = styled(Box)`
  .custom-button {
    padding: 4px 18px;
    border-radius: 8px;
    background-color: ${theme.colors.grey.v1};
    color: black;
    text-transform: none;
    font-family: ${theme.fonts.primary};
    font-size: 16px;

    &.dark {
      margin-left: 14px;
      background-color: black;
      color: white;
    }
  }
`;

const Navbar = () => {
  const { language, menu } = useContext(GlobalContext) || {};
  const query = language === 'es' ? '(max-width: 800px)' : '(max-width: 700px)';

  if (useMediaQuery(query)) {
    return <MobileNavbar menu={menu} />;
  }

  return (
    <Flex
      flexGrow={1}
      justifyContent="space-between"
      alignItems="center"
      pl={5}
    >
      <Dropdown>
        {Array.isArray(menu) &&
          menu.map((item, index) => <Menu menu={item} key={index} />)}
      </Dropdown>

      <ButtonBox>
        <Button href="https://member.clubswan.com/" className="custom-button">
          Log in
        </Button>
        <Button
          href="https://member.clubswan.com/"
          className="custom-button dark"
        >
          Sign up
        </Button>
      </ButtonBox>
    </Flex>
  );
};

export default Navbar;
